import { createContext } from 'react';

import { ICartProduct } from '@/store/ducks/order/types';
import { IAnswer, IProduct } from '@/store/ducks/products/types';

export interface IOptionContext {
  type: 'radio' | 'checkbox' | 'additionals';
  optionIndex: number;
  maxOfAnswers: number;
  answer: IAnswer;
  selectOptionIndex: number;
  action: 'add' | 'receive';
  product: ICartProduct | IProduct;
  optionTitle: string;
}

export const OptionContext = createContext<IOptionContext | null>(null);
